"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

require("../../assets/css/components/form/Field.css");

var _MessageField = require("./MessageField");

var _MessageField2 = _interopRequireDefault(_MessageField);

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

var _ButtonFields = require("./ButtonFields");

var _ButtonFields2 = _interopRequireDefault(_ButtonFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Fields = function (_React$Component) {
    _inherits(Fields, _React$Component);

    function Fields() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Fields);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Fields.__proto__ || Object.getPrototypeOf(Fields)).call.apply(_ref, [this].concat(args))), _this), _this.getGrid = function () {
            if (!_this.props.phoneWidth && !_this.props.tabletWidth) return " mdl-cell--" + (_this.props.width ? _this.props.width : 12) + "-col-desktop";else {
                var estilo = " mdl-cell--" + (_this.props.width ? _this.props.width : 12) + "-col-desktop";
                if (_this.props.phoneWidth) estilo = estilo + " mdl-cell--" + _this.props.phoneWidth + "-col-phone";
                if (_this.props.tabletWidth) estilo = estilo + " mdl-cell--" + _this.props.tabletWidth + "-col-tablet";
                return estilo;
            }
        }, _this.getButton = function () {
            if (_this.props.buttonAction) return _react2.default.createElement(_ButtonFields2.default, { className: "input-btn-" + (_this.props.buttonPosition || "left"), type: _this.props.typeButton || 'button', color: _this.props.buttonColor,
                button: "flat", icon: _this.props.buttonIcon || 'error', onClick: _this.props.buttonAction, tamanho: _this.props.tamanho });
        }, _this.getMaxLengthLabel = function () {
            if (_this.props.maxLength) return _react2.default.createElement(
                "span",
                { className: "maxlength-label" },
                _this.props.currentValue || 0,
                "/",
                _this.props.maxLength
            );
        }, _this.getLabel = function () {
            if (!_this.props.rightLabel) return _react2.default.createElement(
                "label",
                { htmlFor: _this.props.name },
                _this.props.label
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Fields, [{
        key: "getIcon",
        value: function getIcon() {
            if (this.props.icon) return _react2.default.createElement(_Icone2.default, { tamanho: this.props.tamanho, className: "input-icon-" + (this.props.iconPosition || "left"), icone: this.props.icon });
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { required: this.props.required, className: this.props.className + " mdl-textfield mdl-cell" + this.getGrid() },
                this.getLabel(),
                this.getIcon(),
                this.props.children,
                this.getButton(),
                _react2.default.createElement("span", { className: "bar" }),
                _react2.default.createElement(_MessageField2.default, { message: this.props.validateMessage, "aria-hidden": !this.props.validateMessage }),
                this.getMaxLengthLabel()
            );
        }
    }]);

    return Fields;
}(_react2.default.Component);

exports.default = Fields;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/Fields.js
// module id = 109
// module chunks = 0